/* global Word */
export const STYLE_REFS = [
    'body_paragraph',
    'heading_1',
    'heading_2',
    'heading_3',
    'heading_4',
    'slash_bullet_list',
    'numbered_list',
    'quote_type_1',
    'quote_type_2',
];
/** Mapa de estilos da marca (derivado de office_js_style_mapping). */
export const HOUSE_STYLES = {
    body_paragraph: {
        builtIn: 'normal',
        font: { name: 'Muli', size: 11, color: '#1B1B1B' },
        paragraph: { alignment: 'Justified', lineSpacing: 14.4, spaceBefore: 0, spaceAfter: 12 },
    },
    heading_1: {
        builtIn: 'heading1',
        font: { name: 'Styrene A Bold', size: 16, color: '#550899', bold: true },
        paragraph: { spaceBefore: 24, spaceAfter: 6, keepWithNext: true },
    },
    // A hierarquia dos títulos diferencia por TAMANHO e COR (16 roxo → 12 roxo →
    // 11 cinza → 11 lilás sem negrito), como nos estilos Título 1–4 do
    // template.docx. Antes os três subníveis eram iguais (14pt roxo), o que
    // achatava a árvore e divergia do template.
    heading_2: {
        builtIn: 'heading2',
        font: { name: 'Styrene A Bold', size: 12, color: '#550899', bold: true },
        paragraph: { spaceBefore: 18, spaceAfter: 6, keepWithNext: true },
    },
    heading_3: {
        builtIn: 'heading3',
        font: { name: 'Styrene A Bold', size: 11, color: '#3C3C3C', bold: true },
        paragraph: { spaceBefore: 18, spaceAfter: 6, keepWithNext: true },
    },
    heading_4: {
        // Único título sem negrito e o único lugar do corpo em que o lilás é
        // legítimo — por isso `bold: false` explícito (o reforço de negrito das
        // fallbacks não se aplica aqui: a Styrene A Regular é a intenção).
        builtIn: 'heading4',
        font: { name: 'Styrene A Regular', size: 11, color: '#AC4DFF', bold: false },
        paragraph: { spaceBefore: 18, spaceAfter: 6, keepWithNext: true },
    },
    // Os dois estilos de lista: mesmo parágrafo, marcador diferente. O recuo
    // (36/-18 no 1º nível) é do NÍVEL da lista, em HOUSE_LISTS.
    slash_bullet_list: {
        builtIn: 'listParagraph',
        font: { name: 'Muli', size: 11, color: '#1B1B1B' },
        paragraph: { alignment: 'Justified', lineSpacing: 14.4, spaceAfter: 12 },
        list: 'bullet',
    },
    numbered_list: {
        builtIn: 'listParagraph',
        font: { name: 'Muli', size: 11, color: '#1B1B1B' },
        paragraph: { alignment: 'Justified', lineSpacing: 14.4, spaceAfter: 12 },
        list: 'numbered',
    },
    quote_type_1: {
        builtIn: 'quote',
        font: { name: 'Muli', size: 12, color: '#545454', italic: true },
        paragraph: {
            alignment: 'Centered',
            spaceBefore: 12,
            spaceAfter: 12,
            leftIndent: 42.55,
            rightIndent: 42.55,
        },
    },
    quote_type_2: {
        builtIn: 'intenseQuote',
        font: { name: 'Muli', size: 12, color: '#550899', italic: true },
        paragraph: {
            alignment: 'Centered',
            spaceBefore: 12,
            spaceAfter: 12,
            leftIndent: 42.55,
            rightIndent: 42.55,
        },
    },
};
/**
 * Estilo de tabela da marca (components.tables.default_style), equivalente ao
 * estilo "Tabela Norven" do template.docx. A borda é CLARA de propósito: o
 * contraste da tabela vem do cabeçalho roxo, não de uma grade escura.
 */
export const TABLE_STYLE = {
    font: { name: 'Muli', size: 10, color: '#1B1B1B' },
    headerFill: '#550899',
    headerText: '#FFFFFF',
    borderColor: '#F2F2F2',
};
/**
 * Listas NATIVAS da marca, nível a nível. Bullet: o "/" em Courier New dos
 * templates (numeração do "Parágrafo da Lista": texto a 36pt, 72pt e 108pt,
 * marcador 18pt à esquerda). Numerada: "1." / "1.1." / "1.1.1." do estilo
 * "Lista Enumerada", no mesmo recuo do bullet para as duas listas alinharem —
 * a partir do 2º nível o número tem 36pt de espaço, senão "1.1." (mais largo
 * que 18pt em Muli 11) empurra o texto para a próxima tabulação.
 */
export const HOUSE_LISTS = {
    bullet: {
        glyph: '/',
        glyphFont: 'Courier New',
        levels: [
            { textIndent: 36, firstLineIndent: -18 },
            { textIndent: 72, firstLineIndent: -18 },
            { textIndent: 108, firstLineIndent: -18 },
        ],
    },
    numbered: {
        levels: [
            { textIndent: 36, firstLineIndent: -18, numberFormat: [0, '.'] },
            { textIndent: 72, firstLineIndent: -36, numberFormat: [0, '.', 1, '.'] },
            { textIndent: 108, firstLineIndent: -36, numberFormat: [0, '.', 1, '.', 2, '.'] },
        ],
    },
};
/** Tipo de lista de um styleRef de lista; `null` para os demais. */
export function listKindOfRef(ref) {
    var _a;
    return (_a = HOUSE_STYLES[ref].list) !== null && _a !== void 0 ? _a : null;
}
/** O styleRef de cada tipo de lista. */
export function styleRefOfListKind(kind) {
    return kind === 'numbered' ? 'numbered_list' : 'slash_bullet_list';
}
// A política de cor NÃO vive aqui: ela é `color_policy` em
// templates/_base/rules.json — a mesma fonte que o validador lê. Uma cópia
// nesta camada seria um segundo lugar para esquecer de atualizar.
// Chaves do enum `Word.Alignment` pelo mesmo motivo do `builtIn` acima: nada
// que dependa do global `Word` pode ser avaliado no import deste módulo.
const ALIGN = {
    Left: 'left',
    Centered: 'centered',
    Right: 'right',
    Justified: 'justified',
};
export function isStyleRef(s) {
    return !!s && STYLE_REFS.includes(s);
}
/**
 * Aplica um estilo da marca a um parágrafo: estilo nomeado do Word (carrega
 * bordas/aparência do template quando o doc é baseado nele) + formatação direta
 * (garante o visual mesmo em documento em branco / sem a fonte instalada).
 *
 * Estilo de LISTA aplica só a formatação direta: quem põe o parágrafo na lista
 * (e, com isso, no "Parágrafo da Lista") é `word/lists.ts`. Trocar o estilo de
 * um item já na lista o tira dela — foi assim que a lista numerada ficava com
 * número só no 1º item.
 */
export function applyHouseParagraphStyle(para, ref) {
    const s = HOUSE_STYLES[ref];
    // Estilo nomeado: pode falhar se o doc não tiver o estilo; a formatação
    // direta abaixo é o fallback.
    if (!s.list) {
        try {
            para.styleBuiltIn = Word.BuiltInStyleName[s.builtIn];
        }
        catch (_a) {
            /* segue com formatação direta */
        }
    }
    const f = para.font;
    f.name = s.font.name;
    f.size = s.font.size;
    f.color = s.font.color;
    if (s.font.bold !== undefined)
        f.bold = s.font.bold;
    if (s.font.italic !== undefined)
        f.italic = s.font.italic;
    // Propriedades diretas do parágrafo (compatíveis com typings antigos).
    const p = s.paragraph;
    if (p.alignment)
        para.alignment = Word.Alignment[ALIGN[p.alignment]];
    if (p.lineSpacing !== undefined)
        para.lineSpacing = p.lineSpacing;
    if (p.spaceBefore !== undefined)
        para.spaceBefore = p.spaceBefore;
    if (p.spaceAfter !== undefined)
        para.spaceAfter = p.spaceAfter;
    if (p.leftIndent !== undefined)
        para.leftIndent = p.leftIndent;
    if (p.rightIndent !== undefined)
        para.rightIndent = p.rightIndent;
    if (p.firstLineIndent !== undefined)
        para.firstLineIndent = p.firstLineIndent;
    // keepWithNext só existe em paragraphFormat (API mais nova); tenta sem quebrar.
    if (p.keepWithNext !== undefined) {
        try {
            para.paragraphFormat.keepWithNext =
                p.keepWithNext;
        }
        catch (_b) {
            /* versão sem paragraphFormat: ignora */
        }
    }
}
/** Texto já normalizado conforme o estilo (ex.: heading_3 vira CAIXA ALTA). */
export function styleText(text, ref) {
    return HOUSE_STYLES[ref].upper ? text.toLocaleUpperCase('pt-BR') : text;
}
/** Se o estilo exige caixa alta (heading_3). */
export function needsUpper(ref) {
    return !!HOUSE_STYLES[ref].upper;
}
/**
 * Aplica o estilo de tabela da marca: corpo em Muli e o cabeçalho com fundo roxo
 * e texto branco em negrito. Não chama sync — deve ser usada dentro de um
 * Word.run cujo caller faz o sync. `colCount`/`rowCount` permitem agir célula a
 * célula via getCell (sem precisar carregar a coleção de células).
 */
export function applyHouseTableStyle(table, hasHeader, colCount, rowCount) {
    // Normaliza o ESTILO DE PARÁGRAFO de cada célula para Normal ANTES da fonte.
    // Sem isso, uma tabela inserida ancorada logo após um HEADING herda o estilo
    // Heading nos parágrafos das células — e o Sumário (TOC) passa a listar cada
    // célula como se fosse um tópico do documento (bug real em produção). A
    // formatação direta de fonte aplicada abaixo sobrevive à troca de estilo.
    for (let r = 0; r < rowCount; r++) {
        for (let c = 0; c < colCount; c++) {
            table.getCell(r, c).body.paragraphs.getFirst().styleBuiltIn =
                Word.BuiltInStyleName.normal;
        }
    }
    table.font.name = TABLE_STYLE.font.name;
    table.font.size = TABLE_STYLE.font.size;
    table.font.color = TABLE_STYLE.font.color;
    // Bordas finas na cor neutra da marca (API pode não existir em toda versão).
    try {
        const anyTable = table;
        if (anyTable.getBorder) {
            anyTable.getBorder(Word.BorderLocation.all).color = TABLE_STYLE.borderColor;
        }
    }
    catch (_a) {
        /* sem bordas customizadas; usa o padrão do Word */
    }
    if (hasHeader) {
        const header = table.rows.getFirst();
        header.font.color = TABLE_STYLE.headerText;
        header.font.bold = true;
        // Fundo roxo no cabeçalho (TableRow não expõe shading; vai célula a célula).
        for (let c = 0; c < colCount; c++) {
            table.getCell(0, c).shadingColor = TABLE_STYLE.headerFill;
        }
    }
}
